module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAgBAMAAADgTEWFAAAAMFBMVEVHcEz///////////////////////////////////////////////////////////9EPuwCAAAAD3RSTlMAiyNv1wo2BQEEBx0IFy346YqfAAAALklEQVQY02NgQIBradlAkist7QGD/f+PQCbT//8Oo0ximVNDw4FMjtDQA0hhCgDupII1HXe74AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/video_pause_icon.png
// module id = UPOA
// module chunks = 41